import { axios } from "../config";

function getInstitutions(data) {
  return axios.get("api/v1/institutions", {
    params: data,
  });
}

function getInstituteLocations(countryName) {
  return axios.post(`api/v1/institutions/location/?country=${countryName}`);
}

function getInstitutionDetails(id) {
  return axios.get(`api/v1/institutions/${id}`);
}

function getSchoolListToLink(data) {
  return axios.get('api/v1/institutions', {
    params: data
  });
}

function createInstitution(data) {
  return axios.post("api/v1/institutions", data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

function getInstitutionOwners(data) {
  return axios.get("api/v1/institutions/owners", {
    params: data,
  });
}

function createInstitutionOwners(data) {
  return axios.post("api/v1/institutions/owners", data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

function updateInstitutionOwners(id, data) {
  return axios.put(`api/v1/institutions/owners/${id}`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

function deleteInstitutionOwners(id) {
  return axios.delete(`api/v1/institutions/owners/${id}`);
}

function updateInstitution(id, data) {
  return axios.post(`api/v1/institutions/${id}`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

function deleteInstitution(id) {
  return axios.delete(`api/v1/institutions/${id}`);
}

function getInstitutionPaymentHistory() {
  return axios.get(`api/v1/payment/history`);
}

function getPaymentHistoryForExport(data) {
  return axios.post(`api/v1/payment/export-transaction`, data, {responseType: 'blob'});
}

function getInstitutionOverviewStatistics() {
  return axios.get(`api/v1/students/overview`);
}

function suspendInstitution(data) {
  return axios.post("api/v1/institutions/suspend", data);
}

export {
  getInstitutions,
  createInstitution,
  getInstitutionOwners,
  getSchoolListToLink,
  createInstitutionOwners,
  updateInstitutionOwners,
  deleteInstitutionOwners,
  getInstitutionDetails,
  deleteInstitution,
  updateInstitution,
  getInstitutionPaymentHistory,
  getInstituteLocations,
  getInstitutionOverviewStatistics,
  suspendInstitution,
  getPaymentHistoryForExport
};
